import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import { registerChunkReloadHandler } from './utils/chunkReload';

// Recover automatically when a new deployment invalidates the lazily-loaded
// chunks (e.g. Mermaid diagram renderers) referenced by an already-open tab.
registerChunkReloadHandler();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
